export const categories = [
  {
    slug: 'limited-coupons',
    name: '限时优惠券',
    icon: 'ri-coupon-line',
    description: '各大平台限时优惠券每日更新，手慢无！',
    color: 'primary',
    image: 'https://readdy.ai/api/search-image?query=E-commerce%20discount%20coupons%20with%20warm%20orange%20and%20red%20color%20scheme%2C%20shopping%20bags%20and%20gift%20boxes%20on%20minimalist%20beige%20background%2C%20clean%20product%20photography%20style%2C%20soft%20studio%20lighting%2C%20elegant%20composition&width=800&height=600&seq=cat-coupons-01&orientation=landscape'
  },
  {
    slug: 'free-resources',
    name: '免费资源',
    icon: 'ri-gift-line',
    description: '精选免费课程、素材、工具，不花一分钱！',
    color: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Free%20digital%20resources%20collection%20with%20teal%20and%20green%20accents%2C%20laptop%20showing%20download%20icons%2C%20minimalist%20cream%20background%2C%20clean%20modern%20aesthetic%2C%20soft%20natural%20lighting%2C%20editorial%20style&width=800&height=600&seq=cat-free-01&orientation=landscape'
  },
  {
    slug: 'member-benefits',
    name: '会员福利',
    icon: 'ri-vip-crown-line',
    description: '视频会员、音乐会员、生活服务会员专属福利！',
    color: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=Premium%20membership%20card%20and%20VIP%20golden%20badge%20on%20warm%20taupe%20background%2C%20luxury%20membership%20concept%2C%20elegant%20minimalist%20style%2C%20soft%20diffused%20lighting%2C%20clean%20composition&width=800&height=600&seq=cat-member-01&orientation=landscape'
  },
  {
    slug: 'points-exchange',
    name: '积分兑换',
    icon: 'ri-exchange-line',
    description: '信用卡积分、平台积分兑换攻略，价值最大化！',
    color: 'primary',
    image: 'https://readdy.ai/api/search-image?query=Points%20and%20rewards%20exchange%20concept%20with%20golden%20coins%20and%20gift%20icons%2C%20warm%20orange%20atmosphere%2C%20minimalist%20beige%20background%2C%20clean%20studio%20photography%2C%20soft%20lighting&width=800&height=600&seq=cat-points-01&orientation=landscape'
  },
  {
    slug: 'discount-goods',
    name: '折扣好物',
    icon: 'ri-price-tag-3-line',
    description: '超值折扣好物推荐，品质生活不花冤枉钱！',
    color: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Discounted%20quality%20products%20display%20with%20red%20sale%20tags%2C%20lifestyle%20goods%20on%20clean%20cream%20surface%2C%20modern%20minimalist%20aesthetic%2C%20warm%20studio%20lighting%2C%20elegant%20product%20photography&width=800&height=600&seq=cat-discount-01&orientation=landscape'
  },
];

export const categoryArticles: Record<string, Array<{
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  category: string;
  date: string;
  tag: string;
  tagColor: string;
}>> = {
  'limited-coupons': [
    {
      slug: 'taobao-618-coupon-guide',
      title: '淘宝618大促优惠券领取全攻略，最高省500元',
      excerpt: '618年中大促即将来临，各大电商平台优惠券满天飞。本文整理了淘宝平台最全优惠券领取渠道和使用技巧，帮你轻松省下500元！',
      image: 'https://readdy.ai/api/search-image?query=Online%20shopping%20with%20discount%20coupons%20on%20smartphone%2C%20warm%20orange%20e-commerce%20theme%2C%20minimalist%20beige%20background%2C%20clean%20modern%20style%2C%20soft%20lighting&width=800&height=600&seq=art-taobao-01&orientation=landscape',
      category: '限时优惠券',
      date: '2026-08-06',
      tag: '热门',
      tagColor: 'primary',
    },
    {
      slug: 'jd-supermarket-coupon',
      title: '京东超市满199减100优惠券限时领取，仅此一天',
      excerpt: '京东超市推出满199减100大额优惠券，覆盖零食、日用品、母婴等品类。数量有限，先到先得，赶紧来看看怎么领！',
      image: 'https://readdy.ai/api/search-image?query=JD%20supermarket%20online%20shopping%20with%20big%20discount%20banner%2C%20red%20and%20warm%20tones%2C%20minimalist%20beige%20background%2C%20clean%20studio%20photography&width=800&height=600&seq=art-jd-01&orientation=landscape',
      category: '限时优惠券',
      date: '2026-08-06',
      tag: '限时',
      tagColor: 'accent',
    },
    {
      slug: 'meituan-food-coupon',
      title: '美团外卖天天神券领取指南，每单立减5-15元',
      excerpt: '美团外卖近期推出了天天神券活动，每天都可以领取外卖优惠券，配合商家满减活动使用，每单可省5-15元！',
      image: 'https://readdy.ai/api/search-image?query=Food%20delivery%20app%20on%20smartphone%20screen%2C%20warm%20yellow%20and%20orange%20theme%2C%20minimalist%20cream%20background%2C%20clean%20modern%20photography&width=800&height=600&seq=art-meituan-01&orientation=landscape',
      category: '限时优惠券',
      date: '2026-08-05',
      tag: '每日',
      tagColor: 'secondary',
    },
    {
      slug: 'pdd-bargain-guide',
      title: '拼多多百亿补贴真相揭秘，这些商品真的值得买',
      excerpt: '拼多多百亿补贴活动已经持续多年，到底哪些商品真正值得购买？我们为你实测了数码、家电、美妆等品类。',
      image: 'https://readdy.ai/api/search-image?query=Discounted%20electronics%20and%20gadgets%20display%20with%20red%20price%20tags%2C%20minimalist%20beige%20background%2C%20clean%20product%20photography%2C%20soft%20studio%20lighting&width=800&height=600&seq=art-pdd-01&orientation=landscape',
      category: '限时优惠券',
      date: '2026-08-04',
      tag: '测评',
      tagColor: 'primary',
    },
    {
      slug: 'didi-ride-coupon',
      title: '滴滴出行8月优惠合集，新老用户均有打车券',
      excerpt: '滴滴出行8月推出多重优惠活动，新用户注册可领30元无门槛券，老用户每周可领取8折优惠券，通勤族别错过！',
      image: 'https://readdy.ai/api/search-image?query=Ride%20hailing%20app%20interface%20on%20phone%20with%20discount%20badge%2C%20warm%20orange%20theme%2C%20minimalist%20cream%20background%2C%20clean%20modern%20aesthetic&width=800&height=600&seq=art-didi-01&orientation=landscape',
      category: '限时优惠券',
      date: '2026-08-03',
      tag: '出行',
      tagColor: 'accent',
    },
    {
      slug: 'starbucks-buy1get1',
      title: '星巴克买一赠一优惠券限时回归，抓住夏天的尾巴',
      excerpt: '星巴克中国区推出了买一赠一优惠券活动，适用于所有门店。周末约上好友一起喝咖啡，相当于半价享受！',
      image: 'https://readdy.ai/api/search-image?query=Two%20iced%20coffee%20cups%20on%20wooden%20table%2C%20warm%20cafe%20atmosphere%2C%20minimalist%20beige%20background%2C%20clean%20food%20photography%2C%20soft%20natural%20lighting&width=800&height=600&seq=art-starbucks-01&orientation=landscape',
      category: '限时优惠券',
      date: '2026-08-02',
      tag: '餐饮',
      tagColor: 'secondary',
    },
  ],
  'free-resources': [
    {
      slug: 'free-online-courses-2026',
      title: '2026年最全免费在线课程资源整理，从编程到设计一应俱全',
      excerpt: '整理了Coursera、edX、B站等平台上的免费优质课程资源，涵盖编程开发、UI设计、数据分析、外语学习等多个领域。',
      image: 'https://readdy.ai/api/search-image?query=Laptop%20displaying%20online%20learning%20platform%20with%20educational%20icons%2C%20teal%20and%20green%20theme%2C%20minimalist%20cream%20background%2C%20clean%20modern%20style&width=800&height=600&seq=art-courses-01&orientation=landscape',
      category: '免费资源',
      date: '2026-08-05',
      tag: '学习',
      tagColor: 'accent',
    },
    {
      slug: 'free-design-assets-pack',
      title: '设计师必收藏！10个高质量免费设计素材网站推荐',
      excerpt: '设计师做图最怕找不到合适的素材。本文整理了10个高质量免费设计素材网站，包含图标、插画、字体、样机等资源。',
      image: 'https://readdy.ai/api/search-image?query=Design%20assets%20collection%20with%20color%20palette%20and%20typography%20samples%2C%20creative%20workspace%2C%20minimalist%20beige%20background%2C%20clean%20aesthetic&width=800&height=600&seq=art-design-01&orientation=landscape',
      category: '免费资源',
      date: '2026-08-04',
      tag: '设计',
      tagColor: 'accent',
    },
    {
      slug: 'free-ebook-collection',
      title: '豆瓣高分电子书免费下载渠道汇总，爱书人必看',
      excerpt: '整理了多个合法合规的免费电子书下载渠道，包含公版经典文学、开源技术书籍以及各大平台的限时免费活动。',
      image: 'https://readdy.ai/api/search-image?query=Stack%20of%20books%20and%20e-reader%20device%2C%20warm%20reading%20atmosphere%2C%20minimalist%20beige%20background%2C%20cozy%20and%20intellectual%20style&width=800&height=600&seq=art-ebook-01&orientation=landscape',
      category: '免费资源',
      date: '2026-08-03',
      tag: '阅读',
      tagColor: 'accent',
    },
  ],
  'member-benefits': [
    {
      slug: 'video-membership-deals',
      title: '视频会员哪家强？2026年主流视频平台会员权益横向对比',
      excerpt: '腾讯视频、爱奇艺、优酷、B站大会员...到底该买哪个？我们从内容库、画质、价格、联合会员等多个维度进行全面对比。',
      image: 'https://readdy.ai/api/search-image?query=Streaming%20video%20platforms%20on%20tablet%20and%20TV%20screen%2C%20entertainment%20theme%2C%20minimalist%20beige%20background%2C%20clean%20modern%20style&width=800&height=600&seq=art-video-vip-01&orientation=landscape',
      category: '会员福利',
      date: '2026-08-06',
      tag: '对比',
      tagColor: 'secondary',
    },
    {
      slug: 'jd-plus-benefits',
      title: '京东PLUS会员权益详解，这些隐藏福利90%的人不知道',
      excerpt: '京东PLUS会员除了免运费和京豆返还，还有很多隐藏福利。本文详细整理了PLUS会员的全部权益和使用技巧。',
      image: 'https://readdy.ai/api/search-image?query=JD%20PLUS%20membership%20card%20with%20shopping%20benefits%20icons%2C%20warm%20taupe%20theme%2C%20minimalist%20cream%20background%2C%20clean%20product%20photography&width=800&height=600&seq=art-jdplus-01&orientation=landscape',
      category: '会员福利',
      date: '2026-08-04',
      tag: '干货',
      tagColor: 'secondary',
    },
    {
      slug: 'airport-lounge-guide',
      title: '信用卡机场贵宾厅权益使用指南，出行体验翻倍',
      excerpt: '很多信用卡都附赠机场贵宾厅权益，但大多数人不知道怎么用。本文手把手教你如何激活和使用这项权益。',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20airport%20lounge%20interior%20with%20comfortable%20seating%20and%20buffet%2C%20warm%20luxury%20atmosphere%2C%20minimalist%20beige%20background%2C%20clean%20style&width=800&height=600&seq=art-lounge-01&orientation=landscape',
      category: '会员福利',
      date: '2026-08-02',
      tag: '出行',
      tagColor: 'secondary',
    },
  ],
  'points-exchange': [
    {
      slug: 'credit-card-points-guide',
      title: '信用卡积分价值最大化攻略：这样兑换每年多赚2000元',
      excerpt: '不同银行的信用卡积分价值差异巨大。本文整理了主流银行信用卡积分的最佳兑换方案，帮你实现积分价值最大化。',
      image: 'https://readdy.ai/api/search-image?query=Credit%20cards%20and%20reward%20points%20display%2C%20golden%20coins%20concept%2C%20warm%20orange%20theme%2C%20minimalist%20beige%20background%2C%20clean%20photography&width=800&height=600&seq=art-card-pts-01&orientation=landscape',
      category: '积分兑换',
      date: '2026-08-05',
      tag: '攻略',
      tagColor: 'primary',
    },
    {
      slug: 'airline-miles-exchange',
      title: '航空里程兑换机票实战经验，旺季也能换到心仪航班',
      excerpt: '航空里程什么时候兑换最划算？旺季如何抢到里程票？本文分享航空里程兑换的实战经验和技巧。',
      image: 'https://readdy.ai/api/search-image?query=Airplane%20taking%20off%20with%20golden%20sunset%20sky%2C%20travel%20theme%2C%20warm%20orange%20tones%2C%20minimalist%20cream%20background%2C%20clean%20style&width=800&height=600&seq=art-miles-01&orientation=landscape',
      category: '积分兑换',
      date: '2026-08-03',
      tag: '旅行',
      tagColor: 'primary',
    },
  ],
  'discount-goods': [
    {
      slug: 'summer-skincare-deals',
      title: '夏季护肤好物折扣清单，大牌平价替代品全在这',
      excerpt: '夏天到了，护肤品该换季了！本文整理了夏季护肤好物折扣清单，包含防晒、控油、保湿等品类的大牌平替推荐。',
      image: 'https://readdy.ai/api/search-image?query=Summer%20skincare%20products%20arrangement%20with%20natural%20botanical%20elements%2C%20fresh%20green%20and%20cream%20tones%2C%20minimalist%20beige%20background%2C%20clean%20beauty%20photography&width=800&height=600&seq=art-skincare-01&orientation=landscape',
      category: '折扣好物',
      date: '2026-08-06',
      tag: '美妆',
      tagColor: 'accent',
    },
    {
      slug: 'home-appliance-recommend',
      title: '租房党必备！500元以内高性价比小家电推荐',
      excerpt: '租房空间有限，预算有限，但生活品质不能打折。本文推荐了10款500元以内的高性价比小家电，租房党必看！',
      image: 'https://readdy.ai/api/search-image?query=Compact%20home%20appliances%20on%20wooden%20desk%2C%20cozy%20minimalist%20room%2C%20warm%20beige%20and%20cream%20tones%2C%20clean%20lifestyle%20photography&width=800&height=600&seq=art-appliance-01&orientation=landscape',
      category: '折扣好物',
      date: '2026-08-04',
      tag: '家居',
      tagColor: 'accent',
    },
    {
      slug: 'back-to-school-deals',
      title: '开学季数码好物推荐，学生党高性价比装备清单',
      excerpt: '开学季各大电商平台都有数码产品促销活动。本文整理了适合学生党的笔记本电脑、平板、耳机等高性价比装备推荐。',
      image: 'https://readdy.ai/api/search-image?query=Student%20desk%20setup%20with%20laptop%20headphones%20and%20notebooks%2C%20modern%20minimalist%20style%2C%20warm%20cream%20background%2C%20clean%20photography&width=800&height=600&seq=art-school-01&orientation=landscape',
      category: '折扣好物',
      date: '2026-08-02',
      tag: '数码',
      tagColor: 'accent',
    },
  ],
};

export const allArticles = Object.values(categoryArticles).flat();